import { api } from './client';

export async function fetchHomeStats() {
  const { data } = await api.get('/v1/home-stats');
  return {
    cards: Array.isArray(data?.cards) ? data.cards : [],
  };
}
